import {getTodayStartTime, daysBetween} from 'shared/utils/dateTime';
import {saved} from 'core/LifeCycle';

export function createPayload({budget, history}: AppState): TransferMoneyEventPayload {
  const today = getTodayStartTime();
  const daysRemaining = daysBetween(budget.finishDate, today);
  const savedAmount = saved(budget, history);
  return {savedAmount, daysRemaining};
}
